import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ContentSection from './components/ContentSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';

const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Home = () => {
  return (
    <PageWrapper>
      <HeroSection />
    </PageWrapper>
  );
};

export default Home;